import {StorageEngine} from "./storage-engine";

class CookieEngine extends StorageEngine {
  #engine;

  constructor() {
    super();

    try {
      this.#engine = document.cookie;
    } catch (e) {
      console.error(`Ошибка доступа к document.cookie`, e);
    }
  }

  set(key, value, options = {}) {
    super.set(key, value);

    options = {
      path: '/',
      ...options,
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

    for (let optionKey in options) {
      updatedCookie += `; ${optionKey}`;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += `=${optionValue}`;
      }
    }

    try {
      if (this.#engine) {
        this.#engine = updatedCookie;
      }
    } catch (e) {
      console.error(`Ошибка доступа к document.cookie`, e);
    }
  }

  get(key) {
    super.get(key);

    try {
      if (this.#engine) {
        let matches = this.#engine.match(new RegExp(
          "(?:^|; )" + key.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)",
        ));

        return matches ? decodeURIComponent(matches[1]) : undefined;
      }

      return undefined;
    } catch (e) {
      console.error(`Ошибка доступа к document.cookie`, e);
      return undefined;
    }
  }

  remove(key) {
    super.remove(key);

    try {
      if (this.#engine) {
        this.#engine.remove(key);
        this.set(key, ``, {
          "max-age": -1,
        });
      }
    } catch (e) {
      console.error(`Ошибка доступа к document.cookie`, e);
    }
  }
}

export {CookieEngine};
